import cx from 'classnames'
import { ChromePicker } from 'react-color'

import TinyEditorModal from '../TinyEditorModal'

import { Widths, Alignments, SpacingSizes, ButtonEditTabs, LinkToTypes, PixelSizes } from './constants'
import './style.styl'

// The color picker removes leading zeroes when storing hex values,
// so this ensures we had a valid hex value in all cases.
export const coerceToValidHex = (hexString) => {
  // Return early if string is valid hex ( e.g. #02546e ).
  if (hexString.length === 7) {
    return hexString
  } else {
    return `#${hexString.substring(1, hexString.length).padStart(6, '0')}`
  }
}

const ButtonEditContentForm = ({
  buttonCopy,
  setButtonCopy,
  linkValue,
  setLinkValue,
  setLinkToType,
  linkToType,
  urlInputSetup,
}) => (
  <div className="drift-form">
    <fieldset>
      <label>Button Text</label>
      <input className="tiny-button-modal-form-input" type="text" value={buttonCopy} onChange={(e) => setButtonCopy(e.target.value)} />
    </fieldset>
    <fieldset>
      <label>Link To</label>
      <select className="tiny-button-modal-form-input" value={linkToType} onChange={(e) => setLinkToType(e.target.value)}>
        <option value={LinkToTypes.WEB_ADDRESS}>{LinkToTypes.WEB_ADDRESS}</option>
        <option value={LinkToTypes.EMAIL}>{LinkToTypes.EMAIL}</option>
      </select>
    </fieldset>
    <fieldset>
      <label>{urlInputSetup.label}</label>
      <input className="tiny-button-modal-form-input" type="text" placeholder={urlInputSetup.placeholder} value={linkValue} onChange={(e) => setLinkValue(e.target.value)} />
    </fieldset>
  </div>
)

const ButtonEditStyleForm = ({
  borderRadius,
  setBorderRadius,
  bgColorHex,
  setBgColorHex,
  textColorHex,
  setTextColorHex,
  letterSpacing,
  setLetterSpacing,
  paddingSize,
  setPaddingSize,
  textSize,
  setTextSize,
  displayBgColorPicker,
  openBgColorPicker,
  closeBgColorPicker,
  displayTextColorPicker,
  openTextColorPicker,
  closeTextColorPicker,
}) => (
  <div className="drift-form">
    <fieldset>
      <label>Border Radius</label>
      <input type="number" className="tiny-button-modal-form-input tiny-modal-form-small-text-input" value={borderRadius} onChange={(e) => setBorderRadius(e.target.value)} />
    </fieldset>
    <fieldset>
      <label>Background Color</label>
      {displayBgColorPicker &&
        <div className="tiny-button-modal-color-picker-popover">
          <div className="tiny-button-modal-color-picker-cover" onClick={closeBgColorPicker} />
          <div className="tiny-buttom-modal-color-picker-wrapper">
            <ChromePicker
              color={coerceToValidHex(bgColorHex)}
              onChangeComplete={(c) => {setBgColorHex(coerceToValidHex(c.hex))}}
              disableAlpha={true}
            />
          </div>
        </div>
      }
      <div className="tiny-button-modal-form-color-preview" onClick={openBgColorPicker}><div style={{ backgroundColor: coerceToValidHex(bgColorHex) }} className="tiny-button-modal-form-color-preview-square" />{coerceToValidHex(bgColorHex)}</div>
    </fieldset>
    <fieldset>
      <label>Text Color</label>
      {displayTextColorPicker &&
        <div className="tiny-button-modal-color-picker-popover">
          <div className="tiny-button-modal-color-picker-cover" onClick={closeTextColorPicker} />
          <div className="tiny-buttom-modal-color-picker-wrapper">
            <ChromePicker
              color={textColorHex}
              onChangeComplete={(c) => {setTextColorHex(c.hex)}}
              disableAlpha={true}
            />
          </div>
        </div>
      }
      <div className="tiny-button-modal-form-color-preview" onClick={openTextColorPicker}><div style={{ backgroundColor: textColorHex }} className="tiny-button-modal-form-color-preview-square" />{textColorHex}</div>
    </fieldset>
    <fieldset>
      <label>Spacing</label>
      <select className="tiny-button-modal-form-input" value={letterSpacing} onChange={(e) => setLetterSpacing(e.target.value)}>
        {Object.entries(SpacingSizes).map(([name, size]) => {
          return (<option key={size} value={size}>{name}</option>)
        })}
      </select>
    </fieldset>
    <fieldset>
      <label>Text Size</label>
      <select className="tiny-button-modal-form-input" value={textSize} onChange={(e) => setTextSize(e.target.value)}>
        {PixelSizes.map(size => {
          return (<option key={size} value={size}>{size}</option>)
        })}
      </select>
    </fieldset>
    <fieldset>
      <label>Padding</label>
      <select className="tiny-button-modal-form-input" value={paddingSize} onChange={(e) => setPaddingSize(e.target.value)}>
        {PixelSizes.map(size => {
          return (<option key={size} value={size}>{size}</option>)
        })}
      </select>
    </fieldset>
  </div>
)

const ButtonEditSettingsForm = ({
  buttonAlignment,
  setButtonAlignment,
  buttonWidth,
  setButtonWidth,
}) => (
  <div className="drift-form">
    <fieldset>
      <label>Align Button</label>
      <select className="tiny-button-modal-form-input" value={buttonAlignment} onChange={(e) => setButtonAlignment(e.target.value)}>
        {Alignments.map(alignment => {
          return (<option key={alignment} value={alignment}>{alignment}</option>)
        })}
      </select>
    </fieldset>
    <fieldset>
      <label>Width</label>
      <select className="tiny-button-modal-form-input" value={buttonWidth} onChange={(e) => setButtonWidth(e.target.value)}>
        {Object.entries(Widths).map(([name, size]) => {
          return (<option key={size} value={size}>{name}</option>)
        })}
      </select>
    </fieldset>
  </div>
)

const ButtonModalEdit = ({
  activeEditTab,
  onContentTabClick,
  onStyleTabClick,
  onSettingsTabClick,
  ...rest
}) => (
  <div className="tiny-button-modal-section tiny-button-modal-edit-section">
    <div className="tiny-button-modal-edit-tabs">
      <span
        className={cx("tiny-button-modal-edit-tab", { active : activeEditTab === ButtonEditTabs.CONTENT })}
        onClick={onContentTabClick}
      >
        Content
      </span>
      <span
        className={cx("tiny-button-modal-edit-tab", { active : activeEditTab === ButtonEditTabs.STYLE })}
        onClick={onStyleTabClick}
      >
        Style
      </span>
      <span
        className={cx("tiny-button-modal-edit-tab", { active : activeEditTab === ButtonEditTabs.SETTINGS })}
        onClick={onSettingsTabClick}
      >
        Settings
      </span>
    </div>
    <div className="tiny-button-modal-edit-form">
      {activeEditTab === ButtonEditTabs.CONTENT && <ButtonEditContentForm {...rest} />}
      {activeEditTab === ButtonEditTabs.STYLE && <ButtonEditStyleForm {...rest} />}
      {activeEditTab === ButtonEditTabs.SETTINGS && <ButtonEditSettingsForm {...rest} />}
    </div>
  </div>
)


const ButtonModalPreview = ({
  buttonCopy,
  buttonStyle,
  buttonContainerStyle,
  previewButtonLink,
}) => (
  <div className="tiny-button-modal-section tiny-button-modal-preview-section">
    <div style={buttonContainerStyle}>
      <a target="_blank" rel="nofollow" href={previewButtonLink} style={buttonStyle}>{buttonCopy}</a>
    </div>
  </div>
)

export const EditorCtaButtonModal = ({ hideCtaButtonModal, onInsert, existingBtnFound, ...props }) => (
  <TinyEditorModal title={`${existingBtnFound ? 'Update' : 'Insert'} Button`} onClose={hideCtaButtonModal} className="tiny-button-modal-content">
    <div className="playbook-button-modal">
      <div className="tiny-button-modal">
        <ButtonModalEdit {...props} />
        <ButtonModalPreview {...props} />
      </div>
      <div className="tiny-button-modal-footer">
        <div className="tiny-button-modal-footer-button drift-button drift-button-primary" onClick={onInsert}>{existingBtnFound ? 'Update' : 'Insert'}</div>
        <div className="tiny-button-modal-footer-button drift-button drift-button-secondary" onClick={hideCtaButtonModal}>Cancel</div>
      </div>
    </div>
  </TinyEditorModal>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EditorCtaButtonModal/component.js